module.exports = __webpack_public_path__ + "img/red-pack.5eba496d.png";